import { render, staticRenderFns } from "./AppSubCategories.vue?vue&type=template&id=a8af1d54&scoped=true&"
import script from "./AppSubCategories.vue?vue&type=script&lang=js&"
export * from "./AppSubCategories.vue?vue&type=script&lang=js&"
import style0 from "./AppSubCategories.vue?vue&type=style&index=0&id=a8af1d54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8af1d54",
  null
  
)

export default component.exports